// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permissionsmanagement_container_permissions__088ng {
    display: flex;
    flex: 5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.permissionsmanagement_featuredItem__K8Y9E {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor: default;
}

.permissionsmanagement_featuredTitleHeader__hzQNN {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.permissionsmanagement_addPermissionDialog__FMPGc {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.permissionsmanagement_editSystemPermissionsDialog__Ac-n0 {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.permissionsmanagement_flex_row_container__xOM5k {
    display: inline-flexbox;
    flex-direction: row;
    flex: 11 1;
    width: 100%;
    align-items: flex-start;
    align-content: center;
    justify-content: left;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/PermissionsManagement/permissionsmanagement.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;AACzB","sourcesContent":[".container_permissions {\r\n    display: flex;\r\n    flex: 5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor: default;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.addPermissionDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.editSystemPermissionsDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.flex_row_container {\r\n    display: inline-flexbox;\r\n    flex-direction: row;\r\n    flex: 11;\r\n    width: 100%;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_permissions": `permissionsmanagement_container_permissions__088ng`,
	"featuredItem": `permissionsmanagement_featuredItem__K8Y9E`,
	"featuredTitleHeader": `permissionsmanagement_featuredTitleHeader__hzQNN`,
	"addPermissionDialog": `permissionsmanagement_addPermissionDialog__FMPGc`,
	"editSystemPermissionsDialog": `permissionsmanagement_editSystemPermissionsDialog__Ac-n0`,
	"flex_row_container": `permissionsmanagement_flex_row_container__xOM5k`
};
export default ___CSS_LOADER_EXPORT___;
